import React from 'react';
import { Document, Page } from '@react-pdf/renderer';
import PDFTable from './Table';

interface PDFDocumentProps {
  headerData: Record<string, string>;
  data?: Record<string, string>[];
  tableHeaders: any;
}

const PDFDocument = ({ headerData, data, tableHeaders }: PDFDocumentProps) => (
  <Document>
    <Page size="A3" style={{ padding: 20 }} orientation="landscape">
      <PDFTable
        headerData={headerData}
        data={data}
        tableHeaders={tableHeaders}
      />
    </Page>
  </Document>
);

export default PDFDocument;
